<app-header-bar [title]="'Search Results'"></app-header-bar>
<div class="container content-wrap">
  <div class="row" *ngIf="results">
    <div class="col">
      <p >Your search for {{query}} returned {{results.total}} result<span *ngIf="+results.total!=1">s</span></p>
        
    <div *ngIf="results.resources.length>0">

      <h4>Resources</h4>
      <ul class="forum-posts">
        <li *ngFor="let result of results.resources" class="search-result">
            <a [routerLink]="getResourceUrl(result)" class="topic-title">{{result.content_section_title}} > {{result.title}}</a>
        </li>
    </ul>
    </div>

    <div *ngIf="results.forum.length>0">
      <h4>Forum</h4>
      <ul class="forum-posts">
          <li *ngFor="let result of results.forum" class="search-result">
              <a [routerLink]="['/chat', 'forum', 'topic', result.forum_topic_id]" class="topic-title">{{result.category_title}} > {{result.topic_title}}</a>
              <span class="flex-wrap">
                
                <img src="{{avatarBase + result.avatar}}" alt="user avatar" class="avatar rounded" width="40" height="40" *ngIf="result.avatar"> 
                <span class="avatar-icon icon-wrap" *ngIf="!result.avatar">
                  <fa-icon [icon]="['fal', 'user']"></fa-icon>
                </span>
    
  
                <span class="post-list-user">
                  <span class="post-list-username">{{ result.screen_name }}</span>
                  <span class="post-list-userstatus">Status level</span>
                </span>
              </span>
               
                <span class="post-list-info">
                  <span class="post-list-info-date">{{ result.created | timeago:true }} at {{result.created | date : 'h:mma' | lowercase}}</span> 
                  <span class="post-list-info-num text-right"></span>
                </span>
                <span class="post-list-post" *ngIf="result.status==1 || result.status==3">
                  {{ result.post }} 
                </span>
                <span class="post-list-post" *ngIf="result.status==2">
                 This post is currently being moderated.
                </span>
                <hr>
          </li>
      </ul>
    </div>

   


    </div>
  </div>
</div>
